import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
// import jqFooter from '@/components/jqFooter.vue'

const routes = [
  {
    path: '/',
    redirect: '/index',
    children: [{
      path: 'index',
      component: () => import('@/views/index/index'),
      meta: { title: '首页' }
    },{
      path: 'introduce',
      component: () => import('@/views/introduce/index'),
      meta: { title: '产品介绍' }
    },{
      path: 'about',
      component: () => import('@/views/about/index'),
      meta: { title: '关于我们' }
    }
    // ,{
    //   path: 'join',
    //   component: () => import('@/views/join/index'),
    //   meta: { title: '招商加盟' }
    // }
  ]
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  }, 
  { path: "/:pathMatch(.*)*", redirect: '/404', hidden: true }
];

const router = createRouter({
  history: createWebHistory(), // createWebHashHistory(),
  routes
});

export default router;
